import { LOCATION_CHANGE, push } from 'connected-react-router';
import { createMiddleware } from '../../../shared/redux';
import { match } from '../../../shared/utils/match';
import * as AuthService from '../auth-service';
import {
    getUser,
    isSignInFromSignUp,
    rejectSignIn,
    setUser,
} from '../sign-in/sign-in.state';
import {
    acceptChallengeSoftwareTokenMfa,
    CHALLENGE_SOFTWARE_TOKEN_MFA_ACCEPTED,
    CHALLENGE_SOFTWARE_TOKEN_MFA_ISSUED,
    CHALLENGE_SOFTWARE_TOKEN_MFA_REJECTED,
    CHALLENGE_SOFTWARE_TOKEN_MFA_SUBMITTED,
    rejectChallengeSoftwareTokenMfa,
} from './challenge-software-token-mfa-state';
import { ROUTES } from '../auth.constants';
import { redirectToSplashScreen } from '../splash-screen/splash-screen-state';

export const challengeSoftwareTokenMfaMiddleware = createMiddleware({
    [LOCATION_CHANGE]: match((_, action) => action.payload.location.pathname, {
        [ROUTES.CHALLENGE_SOFTWARE_TOKEN_MFA]: state => (getUser(state) ? null : push('/auth/sign-in')),
    }),

    [CHALLENGE_SOFTWARE_TOKEN_MFA_ISSUED]: () => push(ROUTES.CHALLENGE_SOFTWARE_TOKEN_MFA),
    [CHALLENGE_SOFTWARE_TOKEN_MFA_SUBMITTED]: (state, action) => (
        AuthService.confirmSignIn({ user: getUser(state), code: action.payload.code, mfaType: 'SOFTWARE_TOKEN_MFA' })
            .then(user => acceptChallengeSoftwareTokenMfa({ user }))
            .catch(error => rejectChallengeSoftwareTokenMfa({ code: error.code || 'UnknownException', error }))
    ),
    [CHALLENGE_SOFTWARE_TOKEN_MFA_ACCEPTED]: (_, action) => ([
        setUser({ user: action.payload.user }),
        redirectToSplashScreen(),
    ]),
    [CHALLENGE_SOFTWARE_TOKEN_MFA_REJECTED]: (state, action) => (
        rejectSignIn({
            code: action.payload.code,
            error: action.payload.error,
            fromSignUp: isSignInFromSignUp(state),
        })
    ),
});
